const initNewRelic = () => {
  const queryParams = new URLSearchParams(window.location.search);
  if (typeof window.newrelic === 'object') {
    window.newrelic.setCustomAttribute('imp', queryParams.get('imp'));
    window.newrelic.setCustomAttribute('utm_campaign', queryParams.get('utm_campaign'));
    window.newrelic.setCustomAttribute('utm_source', queryParams.get('utm_source'));
  }
};

export default initNewRelic;
